import { Box, styled, Typography } from '@mui/material'

export const Wrapper = styled(Box)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 412px;
  background: ${({ theme }) => theme.palette.custom.white};
  overflow: hidden;
`

export const Header = styled(Box)`
  height: 64px;
  padding: 0 24px;
  box-shadow: 0 1px 0 0 #dde1e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ReplaceTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.custom.gray11};
  font-size: 19px;
  font-weight: 500;
  text-transform: uppercase;
`

export const SearchProductsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
`

export const CategoryRow = styled(Box)`
  display: flex;
  height: 54px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.custom.gray12};
`

export const SearchRow = styled(Box)`
  display: flex;
  height: 54px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.custom.gray12};
`

export const SearchInputWrapper = styled(Box)`
  flex: 1;
  display: flex;
  align-items: center;
  padding: 0 16px;
`

export const SearchIconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  color: ${({ theme }) => theme.palette.custom.gray15};

  & svg {
    width: 16px;
    height: 16px;
  }
`

export const SortIconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  color: ${({ theme }) => theme.palette.custom.gray15};

  & svg {
    width: 16px;
    height: 16px;
  }
`

export const ProductList = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export const ProductItem = styled(Box)`
  height: 88px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.palette.custom.gray12};
  background: ${({ theme }) => theme.palette.custom.white};

  &:hover {
    background: ${({ theme }) => theme.palette.custom.gray4};
  }

  &:last-child {
    border-bottom: none;
  }
`

export const LoaderWrapper = styled(Box)`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PlaceholderWrapper = styled(Box)`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CategorySelectorWrapper = styled(Box)`
  flex: 1;
  display: flex;
  align-items: center;
  padding: 0 16px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.palette.custom.gray4};
  }
`

export const CategoryName = styled(Typography)`
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  color: #4c5783;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
